// @ts-check

import API from './API';
import { GET } from '../utils/Executer';
import { ROTATION_SERVICE_URL as servicePath } from '../constants/APIconstants';

/**
 * @typedef {{
 * id: string,
 * start: string,
 * end: string,
 * userIds: string[],
 * scheduleId: string,
 * rotation: {
 * organizationId: string,
 * ownerId: string[],
 * code: string,
 * name: string,
 * knowledge: string[],
 * url?: string,
 * }
 * }} RotationTimeslot
 */

class RotationsService {
  /**
   *
   * @param {{
   * userIds?: string[],
   * start: Date,
   * end: Date
   * }} param0
   * @returns {Promise<{ success: false } | { success: true, data: Array<RotationTimeslot> }>}
   */
  getTimeslots({ userIds, start, end }) {
    const urlSearchParams = new URLSearchParams();

    if (userIds) {
      for (const userId of userIds) {
        urlSearchParams.append('userIds', userId);
      }
    }

    urlSearchParams.append('start', start.toJSON());
    urlSearchParams.append('end', end.toJSON());

    return API.client.execute(GET, `${servicePath}timeslot?${urlSearchParams}`);
  }
}

export default new RotationsService();
